import React from 'react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';
import { AlertCircle, Loader } from 'lucide-react';

interface CompareStatusProps {
  isLoading: boolean;
  error: Error | null;
}

const CompareStatus: React.FC<CompareStatusProps> = ({ isLoading, error }) => {
  if (isLoading) {
    return (
      <div className="container mx-auto p-4">
        <Alert>
          <Loader className="h-4 w-4 animate-spin" />
          <AlertTitle>Loading</AlertTitle>
          <AlertDescription>
            Please wait while we fetch the match statistics...
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>
            {error instanceof Error ? error.message : 'Failed to load match data'}
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return null;
};

export default CompareStatus;